import React from "react";
import {  RCCGrid } from "react-common-components";
import SortableHandle from "src/components/Sortable/Handle";
import CardActions from "src/pages/Actions/Panel/components/CardActions";
import { IActionCancelRef } from "src/pages/Actions/Panel/components/modalCancel";
import { IActionCommentsRef } from "src/pages/Actions/Panel/components/modalComments";
import { IActionEfficiencyRef } from "src/pages/Actions/Panel/components/modalEfficiency";
import { IActionHistoryRef } from "src/pages/Actions/Panel/components/modalHistory";
import { IActionPostponementRef } from "src/pages/Actions/Panel/components/modalPostponement";
import { IRefModalSubaction } from "src/pages/Actions/Panel/components/modalsSubactions";
import { IActionShowPostponementRef, IListActions, IRefActionsPanelModalAddChangeDelete, IRefActionsProgressModal } from "src/pages/Actions/Panel/interface";
import OptionsOfActions from "src/pages/Actions/Panel/components/OptionsOfActions";
import Handle from "../DroppableContainer/components/Handle";
import { RowKanban } from "../../kanbanModes/MultipleKanbans/interface";

export interface Props {
  value: RowKanban;
	modalsRef?: React.RefObject<IRefActionsPanelModalAddChangeDelete>;
	modalCommentsRef? : React.RefObject<IActionCommentsRef>;
  modalsSubactionsRef?: React.RefObject<IRefModalSubaction>;
  modalProgressRef?: React.RefObject<IRefActionsProgressModal>;
  modalHistoryRef?: React.RefObject<IActionHistoryRef>;
  modalPostponementRef?: React.RefObject<IActionPostponementRef>;
  modalCancelRef?: React.RefObject<IActionCancelRef>;
  modalEfficiencyRef?: React.RefObject<IActionEfficiencyRef>;
	modalShowPostponementsRef?: React.RefObject<IActionShowPostponementRef>;
	onCallbackUpdateFunction?: Function;
	handleProps?: React.HTMLAttributes<any>;
	hideSortableHandle?: boolean;
}

const PlayingCard: React.FC<Props> = (
	{
		value,
		modalCancelRef,
		modalEfficiencyRef,
		modalHistoryRef,
		modalCommentsRef,
		modalPostponementRef, 
		modalProgressRef,
		modalsRef,
		modalsSubactionsRef,	
		modalShowPostponementsRef,
		onCallbackUpdateFunction,
		hideSortableHandle = false
	}) => {
	const options = (row: IListActions) => (
		<RCCGrid
			container
			item
			justifyContent="center"
			alignContent="center"
			alignItems="center"
			style={{  width: hideSortableHandle ? "30px":"60px" }}
		>
			<OptionsOfActions 
				row={row}
				positionOptions="leftEnd"
				actionButtonDelete={() => {
					modalsRef?.current?.actionButtonDelete(row);
				}}
				openModalActionCancel={() => {
					modalCancelRef?.current?.openModalActionCancel(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, () =>  {
						if(onCallbackUpdateFunction)
							onCallbackUpdateFunction(row.inb001Id);
					});
				}}
				openModalActionPostponement={() => {
					modalPostponementRef?.current?.openModalActionPostponement(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, row.inb001Dtfim , () =>  {
						if(onCallbackUpdateFunction)
							onCallbackUpdateFunction(row.inb001Id);
					});
				}}
				openModalAddOrChange={(isDisabled) => {
					modalsRef?.current?.openModalAddOrChange(row.inb001Id, () =>  {
						if(onCallbackUpdateFunction)
							onCallbackUpdateFunction(row.inb001Id);
					}, undefined, undefined, undefined, undefined, undefined, isDisabled);
				}}
				openModalAddSubaction={() => {
					modalsRef?.current?.openModalAddOrChange(undefined, () =>  {
						if(onCallbackUpdateFunction)
							onCallbackUpdateFunction(row.inb001Id);
					});
				}}
				openModalChangeProgress={(isReopen: boolean) => {
					modalProgressRef?.current?.openModalChangeProgress(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, row.inb001PercConclusao , () =>  {
						if(onCallbackUpdateFunction)
							onCallbackUpdateFunction(row.inb001Id);
					}, isReopen);
				}}
			/>

			{!hideSortableHandle && (
				<SortableHandle>
					<Handle />
				</SortableHandle>
			)}
				
			 </RCCGrid>
	);

	return(
		<>
			{value.traceability !== undefined ? (
				<CardActions
					data={value} 
					options={(row: IListActions) => options(row)} 
					openModalComments={(row: IListActions) => {
						if(!modalCommentsRef?.current)
							return;
						modalCommentsRef?.current.openModalActionComments(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, () =>  {
							if(onCallbackUpdateFunction)
								onCallbackUpdateFunction(row.inb001Id);
						} );
					}}
					openModalAttachments={(row: IListActions, showOnlyWithAttachments: boolean) => {
						if(!modalHistoryRef?.current)
							return;

						modalHistoryRef?.current.openModalActionHistory(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, showOnlyWithAttachments,  () =>  {
							if(onCallbackUpdateFunction)
								onCallbackUpdateFunction(row.inb001Id);
						});
					}}
					openModalSubactions={(row: IListActions) => {
						if(!modalsSubactionsRef?.current)
							return;

						modalsSubactionsRef?.current.openModalSubactions(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, "card");
					}}
					openModalPostPonementConfirm={(row: IListActions) => {
						if(!modalPostponementRef?.current)
							return;
						modalPostponementRef?.current.openModalActionPostponementConfirm(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`,  () =>  {
							if(onCallbackUpdateFunction)
								onCallbackUpdateFunction(row.inb001Id);
						});
					}}
					openModalCancelConfirm={(row: IListActions) => {
						if(!modalCancelRef?.current)
							return;
						modalCancelRef?.current.openModalActionCancelConfirm(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`,  () =>  {
							if(onCallbackUpdateFunction)
								onCallbackUpdateFunction(row.inb001Id);
						});
					}}
					openModalEfficiency={(row: IListActions) => {
						if(!modalEfficiencyRef?.current)
							return;
						modalEfficiencyRef?.current.openModalActionEfficiency(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`,  () =>  {
							if(onCallbackUpdateFunction)
								onCallbackUpdateFunction(row.inb001Id);
						});
					}}
					openModalChangeProgress={(row: IListActions) => {
						if(!modalProgressRef?.current)
							return;
						modalProgressRef.current.openModalChangeProgress(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, row.inb001PercConclusao , () =>  {
							if(onCallbackUpdateFunction)
								onCallbackUpdateFunction(row.inb001Id);
						});
					}}
					openModalShowPostponements={(row: IListActions) => {
						if(!modalShowPostponementsRef?.current)
							return;
						modalShowPostponementsRef.current?.openModalActionShowPostponements(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`);
					}}
				/>
			) : null}
		</>
	);
};

export default PlayingCard;
